// ============================================================
// src/components/ConsultationCTA.jsx
// Ayurvedic consultation banner — WhatsApp redirect
// ============================================================

import "./ConsultationCTA.css";

export default function ConsultationCTA() {
  const waLink =
    "https://wa.me/918368402126?text=Hi%2C%20I%20would%20like%20to%20book%20a%20free%20consultation";

  return (
    <div className="consult-wrap">
      <div className="consult-box">
        <h5 className="consult-heading">
          Get personalized Ayurvedic guidance from our certified wellness experts.
        </h5>
        <p className="consult-sub">
          Share your health concerns and receive natural, result-oriented
          recommendations tailored just for you
        </p>
        <a
          className="consult-btn"
          href={waLink}
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="ti ti-brand-whatsapp" aria-hidden="true" />
          Book Free Consultation
        </a>
      </div>
    </div>
  );
}